export interface ExpiredDate {
  expMonth: string;
  expYear: string;
}

export interface TokenizeAdditionalProps {
  stored: boolean;
  cardholder: string;
  accountId: string;
  accessToken: string;
}

export interface TokenizeRequestPayload
  extends ExpiredDate,
    TokenizeAdditionalProps {
  cvv: string;
  cardNumber: string;
}

export interface TokenizeResponsePayloadSuccess {
  token: string;
  card: CardResponsePayload;
  error?: never;
}

export interface TokenizeResponsePayloadError {
  error: {
    message: string;
  };
}

interface CardResponsePayload extends ExpiredDate {
  bin: string;
  last4: string;
  cardholder: string;
  stored: boolean;
}

export type TokenizeResponsePayload =
  | TokenizeResponsePayloadSuccess
  | TokenizeResponsePayloadError;

export function isTokenizeErrorResponse(
  value: TokenizeResponsePayload
): value is TokenizeResponsePayloadError {
  return value.error !== undefined;
}
